import App from './App/App.svelte';
const app = new App({
    target: document.body,
});
export default app;
